module.exports = __webpack_public_path__ + "static/media/icon2.6534f0bb.png";